import React, { useMemo } from "react";
import { TableProps } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Button from "~/shared/ui/Fields/Button";
import { getStaffFilterPreset } from "~/components/Forms/DealerPassportForm2/Employee/lib/staffFilterPreset";
import { useGetDealerEmployees } from "~/entity/Users/hooks/useGetDealerEmployees";
import { setCookie } from "~/hooks/filterCookie";
import { TableV2 } from "~/shared/ui/TableV2";

import s from "./Employee.less";

interface DealerUser {
  id: number;
  fullName: string;
  email: string;
  phone: string;
  role: string;
}

const Employee = ({ DealerId }: { DealerId: string }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const { data: employees, isLoading } = useGetDealerEmployees(DealerId);

  const dataSource = useMemo<DealerUser[]>(() => {
    if (!employees) return [];
    return employees.map((user) => ({
      id: user.id,
      fullName: user.fullName || "-",
      email: user.email || "-",
      phone: user.phone || "-",
      role: user.roleName || "-",
    }));
  }, [employees]);

  const columns = useMemo<TableProps<DealerUser>["columns"]>(
    () => [
      {
        title: t("users.fullname"),
        dataIndex: "fullName",
        key: "fullName",
        width: 250,
      },
      {
        title: t("users.email"),
        dataIndex: "email",
        key: "email",
      },
      {
        title: t("users.phone"),
        dataIndex: "phone",
        key: "phone",
      },
      {
        title: t("users.role"),
        dataIndex: "role",
        key: "role",
        width: 250,
      },
    ],
    [t],
  );

  const goToEmployee = () => {
    const filterPreset = getStaffFilterPreset({ id: DealerId });
    setCookie("filterEmployee", JSON.stringify(filterPreset), 3);
    history.push("/base/staff");
  };

  return (
    <div className={s.container}>
      <div className={s.topWrapper}>
        <span>{t("employee.usersSystem")}</span>
        <Button
          txtBtn={t("employee.goToAll")}
          onClick={goToEmployee}
          customClassName={s.btn}
        />
      </div>
      <TableV2
        dataSource={dataSource}
        columns={columns}
        loading={isLoading}
        stripedRows={false}
        noHorizontalScroll={true}
      />
    </div>
  );
};

export default Employee;
